import { SubTabsContainer, SubTab } from './styles';

interface SubTabsProps {
  tabs: string[];
  activeTab: string;
  onChange: (tab: string) => void;
}

export const SubTabs = ({ tabs, activeTab, onChange }: SubTabsProps): JSX.Element => (
  <SubTabsContainer>
    {tabs.map((tab) => (
      <SubTab
        key={tab}
        active={tab === activeTab}
        onClick={() => onChange(tab)}
      >
        {tab}
      </SubTab>
    ))}
  </SubTabsContainer>
);
